import { MessageCircle, Phone } from "lucide-react";
import { BRAND } from "../data/content";

const FloatingButtons = () => {
    const waMsg = encodeURIComponent(
        "Hi Sam, I saw the Samora Spaces studio online. I'd like to talk about my home."
    );
    const waUrl = `https://wa.me/${BRAND.whatsapp}?text=${waMsg}`;

    return (
        <>
            <a
                href={waUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="floating-whatsapp"
                aria-label="Chat on WhatsApp"
                className="fixed z-40 bottom-24 md:bottom-8 right-5 md:right-8 w-14 h-14 md:w-16 md:h-16 bg-[#25D366] hover:bg-samora-gold text-white flex items-center justify-center shadow-2xl transition-all duration-500 hover:scale-105"
            >
                <MessageCircle size={26} strokeWidth={1.5} />
            </a>
            <a
                href={`tel:${BRAND.phoneRaw}`}
                data-testid="floating-call"
                aria-label="Call studio"
                className="fixed z-40 bottom-44 md:bottom-28 right-5 md:right-8 w-12 h-12 md:w-14 md:h-14 bg-samora-ink hover:bg-samora-gold text-white flex items-center justify-center shadow-xl transition-all duration-500 hover:scale-105"
            >
                <Phone size={20} strokeWidth={1.5} />
            </a>
        </>
    );
};

export default FloatingButtons;
